<template>
  <!-- phones get the OS time wheel, which beats typing on a small keyboard. at a desk the box takes
       typed entry -- "1230 am", "130p", "9", "1800" -- and rewrites itself to how it was read. -->
  <b-form-input
    v-if="native"
    :value="value"
    type="time"
    size="sm"
    :class="inputClass"
    :aria-label="label"
    @input="$emit('input', $event)"
  />
  <b-form-input
    v-else
    v-model="text"
    type="text"
    size="sm"
    :class="inputClass"
    :state="text && !parsed ? false : null"
    placeholder="1:30 pm"
    :aria-label="label"
    @focus="select_all"
    @blur="commit"
    @keyup.enter="commit"
  />
</template>

<script>
import { format_time_input, parse_time_input } from '../utils/parse_time_input'

export default {
  name: 'GmsTimeInput',
  props: {
    // 'HH:mm', the same shape a native time input carries
    value: { type: String, default: '' },
    native: { type: Boolean, default: false },
    inputClass: { type: String, default: '' },
    // an accessible name: both instances used to announce as just "time", so From and To were
    // indistinguishable, and the native branch had no name at all (FI-2169 review)
    label: { type: String, default: 'time' },
  },

  data() {
    return {
      text: format_time_input(this.value),
    }
  },

  computed: {
    parsed() {
      return parse_time_input(this.text)
    },
  },

  watch: {
    value(next) {
      // a quick window button or an overnight roll moved the time under us
      if (next != this.parsed)
        this.text = format_time_input(next)
    },
  },

  methods: {
    // clicking in means you are about to type a time, not edit the one that's there: the whole
    // value is selected so the first keystroke replaces it. only on focus, so a second click can
    // still place the caret if someone does want to edit.
    select_all(event) {
      const field = event && event.target
      if (!field || !field.select)
        return
      // the browser puts the caret where you clicked just after focus, so this waits for that.
      // asks the field's own document rather than the global one, so it stays testable.
      const owner = field.ownerDocument
      setTimeout(() => {
        if (!owner || owner.activeElement == field)
          field.select()
      }, 0)
    },

    commit() {
      const parsed = this.parsed
      if (!parsed) {
        // unreadable: put back the time that is actually in effect rather than keeping a value
        // nobody can act on
        this.text = format_time_input(this.value)
        return
      }
      this.text = format_time_input(parsed)
      if (parsed != this.value)
        this.$emit('input', parsed)
    },
  },
}
</script>
